import React from 'react';
import styles from './barcode.module.css'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog'; 
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import PrintRoundedIcon from '@material-ui/icons/PrintRounded';
import Barcode  from 'react-barcode';
import List from '@material-ui/core/List'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BarCodeComp = (props) => {
    return (
        <div className={styles.container}>
            <Dialog fullScreen open={props.open} onClose={props.onClose   } TransitionComponent={Transition}>
                <AppBar className={styles.appBar}>
                    <Toolbar className={styles.toolBar}>
                        <div className={styles.leftContent}>
                            <IconButton edge="start" color="inherit" onClick={props.onClose } aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={styles.title}>
                                {props.product.productName}
                            </Typography>
                        </div>
                        <Button autoFocus endIcon={<PrintRoundedIcon />} onClick={() => window.print()}>Print</Button>
                    </Toolbar>
                </AppBar>
                <List>
                <div className={styles.container}>
                    {props.product.productParts.map(val => {
                        return (
                            <Barcode value={val._id} />
                        )
                    })} 
                </div>
                </List>
            </Dialog>
        </div>
    )
}

export default BarCodeComp;